module.exports = "<div class=zl-am> <vk-modal :show=modalAuth.show @hide=hideModals> <authentication></authentication> </vk-modal> <tm-modal :show=modal.show :block=modal.block :icon=modal.icon :text=modal.text :spinner=modal.spinner :request-error=modal.requestError @hide=hideModals> </tm-modal> <vk-modal-confirm :show=modalConfirm.show :text=modalConfirm.text :icon=modalConfirm.icon @hide=hideModals @confirm=\"$broadcast('modal:confirmed')\"> </vk-modal-confirm> <products></products> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
 ** module id = 257
 ** module chunks = 0
 **/